const getApiDomain = (): string => {
  const domain = import.meta.env.VITE_API_DOMAIN || "";
  return domain.replace(/\/+$/, ""); // Remove trailing slashes
};

const API_DOMAIN = getApiDomain();

/**
 * API Endpoints Configuration
 *
 * Priority order:
 * 1. If individual environment variable is set, use it
 * 2. Otherwise, construct from VITE_API_DOMAIN
 */
export const apiConfig = {
  GRAPHQL_SERVER:
    import.meta.env.VITE_GRAPHQL_SERVER || `${API_DOMAIN}/api/graphql`,

  GRAPHQL_SERVER_CNC:
    import.meta.env.VITE_GRAPHQL_SERVER_CNC || `${API_DOMAIN}/api/v0`,

  ACCOUNTS_GRAPHQL_SERVER:
    import.meta.env.VITE_ACCOUNTS_GRAPHQL_SERVER ||
    `${API_DOMAIN}/api/accountsgraphql`,

  REST_API_URL:
    import.meta.env.VITE_REST_API_URL || `${API_DOMAIN}/gateway/v1/`,

  // PostHog ingestion goes through our own reverse proxy only — never directly
  // to PostHog Cloud, so ad/tracker blockers can't drop the traffic. The path is
  // deliberately tool-agnostic (`/ingest`, not `/posthog`) for the same reason.
  POSTHOG_PROXY_URL:
    import.meta.env.VITE_POSTHOG_PROXY_URL || `${API_DOMAIN}/ingest`,

  // PostHog's own UI host — used for toolbar/app links only, never for
  // ingestion, so it stays un-proxied. US is the default (and only) region
  // today; overridable via env for future regions.
  POSTHOG_UI_HOST:
    import.meta.env.VITE_POSTHOG_UI_HOST || "https://us.posthog.com",
} as const;
